import React from "react";
import Navbar from "./Navbar";
import OTPLoginComponent from "../component/OTPLoginComponent";

const Login = () => {
  return (
    <div className="nz-auth-page-layout">
      <Navbar />
      <div className="nz-auth-card-wrapper">
        <OTPLoginComponent
          title="Customer Login"
          subTitle="Access your Nearzon account"
          registerPath="/customer-register"
        />
      </div>
    </div>
  );
};

export default Login;
